export default __webpack_public_path__ + "static/illustration-card-two.url-d6335b846e1c57ea32081c5cd82aeaac.svg";